/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { Result } from "../../network/http-client"
import type { ViewModel } from "../../viewmodel/viewmodel"

import type { UserTotpService } from "./user-totp-service"
import type { UserTotpStore } from "./user-totp-store"
import type { TotpCode } from "./user-types"

export class UserTotpViewModel implements ViewModel {
    name: string = this.constructor.name

    constructor(
        private readonly store: UserTotpStore,
        private readonly service: UserTotpService
    ) {}

    get totpImageUrl(): string | null {
        return this.store.totpImageUrl
    }

    clearTotpCode(): void {
        this.store.clearTotpCode()
    }

    async generateTotp(): Promise<Result<TotpCode>> {
        return await this.service.generateTotp()
    }

    async disableTotp(code: string): Promise<Result<void>> {
        return await this.service.disableTotp(code)
    }

    async confirmTotp(code: string): Promise<Result<void>> {
        return await this.service.confirmTotp(code)
    }

    async resetTotp(userId: number): Promise<Result<void>> {
        return await this.service.resetTotp(userId)
    }
}
